import RevolvingMembershipCard from './RevolvingMembershipCard';
import { VerticalSeparator } from './utils';

export function TelegramAppForMobileUnconfigured() {
    return (
        <div style={{ width: '360px', paddingLeft: '10px', paddingRight: '10px' }}>
            <div style={{ width: '340px' }}>
                <VerticalSeparator height='30px' />
                <div>
                    <RevolvingMembershipCard
                        name='Member'
                        cardId='00000000'
                    />
                </div>
                <VerticalSeparator />
                <p className="app-text">Say <code>Hello</code> in chat to get set up.</p>
                <VerticalSeparator />
                <p className="app-text">If you are already a existing member, you will be guided through the process. You will need to provide your Card ID, and verify with either (i) your email address, (ii) your mobile number, or (iii) your date of birth.</p>
                <VerticalSeparator />
                <p className="app-text">Even if you are not already a member,</p>
                <p className="app-text">do say <code>Hello</code> anyway to get a personalised registration button. Click on it to sign up for Cool Rewards membership, and complete your set up.</p>
                <VerticalSeparator />
            </div>
        </div>
    );
}
